<template>
    <div class="worldcup-menu">
        <div v-for="(item, index) in listMenu" :key="index" :class="{'active':value === index}" class="worldcup-menu__item text-center" @click="ClickShowComponent(index)">
            <div class="icon">
                <img :src="item.icon" alt="icon">
            </div>
            <div class="text">{{item.text}}</div>
            <div class="line">
                <img :src="`${$store.state.mapDomain.STATIC_URL}/assets/img/event/worldcup/line-worldcup-menu.svg`" alt="line">
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        value: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            listMenu: [
                {
                    icon: '/assets/img/event/worldcup/menu-prize.png',
                    text: 'GIẢI THƯỞNG'
                },
                {
                    icon: '/assets/img/event/worldcup/menu-rancing.png',
                    text: 'ĐUA TOP'
                },
                {
                    icon: '/assets/img/event/worldcup/menu-earn.png',
                    text: 'kiếm lượt chơi'
                },
                {
                    icon: '/assets/img/event/worldcup/menu-history.png',
                    text: 'LỊCH SỬ THƯỞNG'
                }
            ]
        };
    },
    methods: {
        ClickShowComponent(index) {
            this.$emit('input', index);
        }
    }
};
</script>
